const detailHeroMapping = (data) => {
  const firstCta = data.field_ctas[0]
  const secondCta = data.field_ctas[1]
  const nutritionCta = data.field_nutrition_cta[0]
  const mappedData = {
    heroImageDesktopSrc: data.field_desktop_img[0]?.url || '',
    heroImageMobileSrc: data.field_mobile_img[0]?.url || '',
    heroImageTopBackgroundDesktopSrc: data.field_desktop_bg_img[0]?.url || '',
    heroImageTopBackgroundMobileSrc: data.field_mobile_bg_img[0]?.url || '',
    heroImageBottomBackgroundSrc: data.field_ingredients_image[0]?.url || '',
    heroImageAlt: data.field_desktop_img[0]?.alt || '',
    title: data.field_product_name[0]?.value,
    heroParagraph: data.field_product_description[0]?.value,
    firstCta: {
      title: firstCta?.field_thumbnail_img[0]?.title || '',
      alt: firstCta?.field_thumbnail_img[0]?.alt || '',
      imageContent: firstCta?.field_thumbnail_img[0]?.url || '',
      href: firstCta?.field_cta[0]?.url || '/',
      ariaLabel: firstCta?.options?.attributes['aria-label'] || '',
    },
    secondCta: {
      title: secondCta?.title || '',
      alt: secondCta?.options?.attributes['aria-label'] || '',
      href: secondCta?.uri || '/',
      ariaLabel: secondCta?.options?.attributes['aria-label'] || '',
    },
    nutritionCta: {
      title: nutritionCta?.title || '',
      alt: nutritionCta?.options?.attributes['aria-label'] || '',
      href: nutritionCta?.url || '/',
      ariaLabel: nutritionCta?.options?.attributes['aria-label'] || ''
    }
  };
  return mappedData;
};

export default detailHeroMapping;
